import { render, staticRenderFns } from "./groupTests.vue?vue&type=template&id=74043b34&"
import script from "./groupTests.vue?vue&type=script&lang=js&"
export * from "./groupTests.vue?vue&type=script&lang=js&"
import style0 from "./groupTests.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports